import React from "react"

const Title = props => {
  let fontSize
  let heading

  if (props.size === 2) {
    fontSize = "2"
  } else {
    fontSize = "1"
  }

  if (props.heading) {
    heading = props.heading
  } else {
    heading = 2
  }

  const CustomHeading = `h${heading}`
  const fontStyle = `font-style_${fontSize}`
  const extraClass = props.extraClass ? " " + props.extraClass : ""

  return (
    props.text && (
      CustomHeading !== `h1` ? (
        <CustomHeading
        className={fontStyle + " animTxt animTxt_2" + extraClass}
        style={{ textAlign: props.align }}
      >
        <span>{props.text}</span>
        </CustomHeading>
      ) : (
        <div
        className="animTxt animTxt_2"
        >
          <h1 className="font-style_2 mainTitle">{props.text}</h1>
        </div>
      )
    )
  )
}

export default Title
